import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Rs_Add from "./rs_add";
import Rs_Edit from "./rs_edit";
import Td_Sel from "../../../lib/ui/td_sel";

class Tbv_Rs extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.state = {};
    this.state.rsa = [];
    this.state.tra = [];
    this.state.msg = {};
    this.state.wnds = {};
    this.state.sortid = "";
    this.state.sortdir = 1;

      if(props.wnds) {
          this.state.rsa = props.wnds.rsa;
      }
      this.selitems = [
          {fkn: 'open', text: 'ÖPPNA'},
          {fkn: 'prn', text: 'SKRIV UT'}
      ];
   }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      this.rs_list();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tab_style(tabid) {
      var css = {};
      css.display = "none";
      if(this.state.tabval === tabid) css.display = "block";
      return css;
    }
    bq_close() {
		this.props.ctx.setState({ wnds: {} });
	};
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      css.overflow = "auto";
      return css;
  }
    th_style(id) {
        var css = {};
        css.cursor = "pointer";
        if(id == this.state.sortid) {
            if(this.state.sortdir) css.color = "#800";
            else css.color = "#080";
        }
        return css;
    }
    rs_list() {
    var self = this;
    var prm = {};
      //prm.req = "pms.rs.qs_rs";
      prm.req = "pos.pos_rs.rsa";

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({rsa: ret.rca });
        self.syncTb("rsTable");
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  row_bong(row) {
    var self = this;
    var prm = {};
    prm.req = "pos.pos_bq.bongrow";
    prm.row = row;
    prm.status = "09";

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        //self.setState({bqa: ret.rca });
        //toastr.success("OK", "SAPI");
        var msg = { ok: true, text: "BONGAD ..." };
        self.setState({msg: msg });
        setTimeout(function(){
            self.setState({msg: {} });
        }, 1000);
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  prn(event) {
  }
    rs_add() {
        var self = this;

        var wnds = {};
        wnds.rsadd = true;
        self.setState({wnds: wnds });
    }
    rs_edit(rso) {
        var self = this;

        var wnds = {};
        wnds.rsedit = true;
        wnds.rso = rso;
        wnds.rsa = this.state.rsa;
        self.setState({wnds: wnds });
    }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
            tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
                width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
    tb_sort(typ) {
        var self = this;
        //var rvs = self.state.rvs;
        var tha = self.state.tha;
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;

        if(sortid != typ) sortdir = 0;
        else {
            if(sortdir) sortdir = 0;
            else sortdir = 1;
        }

        if(typ) {
            if(sortdir) tha.sort((a,b) => (a[typ] < b[typ]) ? 1 : ((b[typ] < a[typ]) ? -1 : 0));
            else tha.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
        }
        self.setState({ tha: tha, sortid: typ, sortdir: sortdir });
    }
    th_icon(typ) {
        var cls = "";
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;
        if(sortid == typ)
        {
            if(sortdir) cls = "fa fa-caret-up";
            else cls = "fa fa-caret-down";
        }
        return cls;
    }

  render() {
    //if(!this.props.wnds.rs) return "";

    var title = this.props.title;
    if(!title) title = "Titel";

	var html =
        <div className="mx_base">
        { this.props.wnds.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_90 flex-col" style={ this.dlg_style() }>
        <div className="mx_content flex">

            <div className="flex-row" style={{padding:"5px",height:"35px"}}>
                    <div className="flex-col flex">
                        <div>Resurser</div>
                    </div>
                    <div className="flex-col">
                        <div>UPPDATERA</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

        <div id="rsTable" className="web-col">
            <table className="table table-bordered table-hover tb" style={{marginBottom: "0px"}}>
                <thead>
                <tr>
                <th style={ this.th_style("boktyp") } onClick={() => this.tb_sort("boktyp") }>Boktyp <i className={ this.th_icon("boktyp") }></i></th>
                <th style={ this.th_style("restname") } onClick={() => this.tb_sort("restname") }>Text <i className={ this.th_icon("restname") }></i></th>
                <th style={ this.th_style("resursordn") } onClick={() => this.tb_sort("resursordn") }>Sort <i className={ this.th_icon("resursordn") }></i></th>
                <th style={ this.th_style("platser") } onClick={() => this.tb_sort("platser") }>Platser <i className={ this.th_icon("platser") }></i></th>
                <th style={ this.th_style("fromtime") } onClick={() => this.tb_sort("fromtime") }>Från <i className={ this.th_icon("fromtime") }></i></th>
                <th style={ this.th_style("tilltime") } onClick={() => this.tb_sort("tilltime") }>Till <i className={ this.th_icon("tilltime") }></i></th>
                <th style={ this.th_style("iresurs") } onClick={() => this.tb_sort("iresurs") }>ID <i className={ this.th_icon("iresurs") }></i></th>
                <th style={ this.th_style("reservtime") } onClick={() => this.tb_sort("reservtime") }>Reservationstid <i className={ this.th_icon("reservtime") }></i></th>
                <th style={ this.th_style("upddat") } onClick={() => this.tb_sort("upddat") }>Uppdaterad <i className={ this.th_icon("upddat") }></i></th>
                <th></th>
                </tr>
                </thead>
            </table>
            <div className="tb-cdi" style={ this.tb_style() }>
            <table className="table table-bordered table-hover tb">
                <tbody>
                { this.state.rsa.map((row, key) =>
                <tr key={key} onDoubleClick={() => this.rs_edit(row) }>
                    <td>{ row.boktyp }</td>
                    <td>{ row.restname }</td>
                    <td>{ row.resursordn }</td>
                    <td>{ row.platser }</td>
                    <td>{ row.fromtime }</td>
                    <td>{ row.tilltime }</td>
                    <td>{ row.iresurs }</td>
                    <td>{ row.reservtime }</td>
                    <td>{ row.upddat }</td>
                    <td>
                        <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                    </td>
                </tr>
                )}
                </tbody>
            </table>
            </div>
        </div>
        </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.bq_close() } >
                STÄNG
            </button>
            <div className="flex-row"></div>
            <button className="btn btn-hw-blue w250" onClick={() => this.rs_add() } >
                LÄGG TILL
            </button>
            <div className="flex-row"></div>
            <button className="btn btn-hw-green w250 hide" onClick={(event) => this.prn(event) } >
                SKRIV UT
            </button>
        </div>
      </div>
            { this.state.wnds.rsadd ? <Rs_Add wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true} /> : null}
            { this.state.wnds.rsedit ? <Rs_Edit wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true} /> : null}
        <Wnd_Ok msg={this.state.msg} ctx={this} />
    </div>
	;
	return html;
  };
}

export default Tbv_Rs;